/**
 * =============================================================================
 * WlAddonRevenueTrendChart
 *
 * Wrapper fino sobre `WlRevenueTrendChart` para reuso 100% do gráfico
 * evolutivo de 12 meses. Alimenta com `trend_revenue` do payload da RPC
 * `wl_get_addon_kpis`. Mesma paleta, mesmo toggle bar/line, mesma UX.
 *
 * @version 1.0.0
 * RELEASE: 2026-07-22 v1.0.0 - Versão inicial (aba Add-ons — WL Financeiro).
 * =============================================================================
 */
import { WlRevenueTrendChart } from './WlRevenueTrendChart';
import type { ChartTypeMode } from './ChartTypeToggle';
import type { WlAddonRevenuePoint } from '@/hooks/wl/useWlAddonKpis';

interface Props {
  data: WlAddonRevenuePoint[];
  mode?: ChartTypeMode;
  onModeChange?: (mode: ChartTypeMode) => void;
}

/** Evolução do MRR de add-ons (12 meses) — reuso direto do trend chart genérico. */
export function WlAddonRevenueTrendChart({ data, mode, onModeChange }: Props) {
  // Payload já compatível: WlRevenueTrendChart lê `mrr` (total). Aqui não há
  // composição planos/add-ons, então o modo barras cai no fallback (barra única).
  return (
    <WlRevenueTrendChart
      data={data as any}
      mode={mode}
      onModeChange={onModeChange}
    />
  );
}
